module.exports = __webpack_public_path__ + "static/img/image.224c1867.png";